import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t, language } = useLanguage();

  return (
    <section id="contact" className="section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <h2>{t('contactTitle')}</h2>
          <p style={{ maxWidth: '600px', margin: '0 auto', color: 'var(--text-secondary)' }}>
            {t('contactSubtitle')}
          </p>
        </div>

        <div style={{ maxWidth: '480px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '36px' }}>
            <h3 style={{ marginBottom: '16px' }}>{t('letsConnect')}</h3>
          </div>

          {/* Contact Links Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginBottom: '36px'
          }}>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/olivier-gautheron-og/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                background: 'var(--card-bg)',
                border: '2px solid var(--border-color)',
                borderRadius: '10px',
                textDecoration: 'none',
                color: 'var(--text-primary)',
                transition: 'all 200ms ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)';
                e.target.style.borderColor = 'var(--border-hover)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.borderColor = 'var(--border-color)';
              }}
            >
              <div style={{
                width: '44px',
                height: '44px',
                background: '#0077B5',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </div>
              <div style={{ textAlign: 'left' }}>
                <h4 style={{
                  margin: '0 0 4px 0',
                  fontSize: '15px',
                  fontWeight: '600',
                  color: 'var(--color-primary)'
                }}>
                  LinkedIn
                </h4>
                <p style={{
                  margin: 0,
                  fontSize: '12px',
                  color: 'var(--text-secondary)'
                }}>
                  {(language === 'en' ? 'Let\'s connect' : 'Connectons-nous professionnellement')}
                </p>
              </div>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/+33623306587"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                background: 'var(--card-bg)',
                border: '2px solid var(--border-color)',
                borderRadius: '10px',
                textDecoration: 'none',
                color: 'var(--text-primary)',
                transition: 'all 200ms ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)';
                e.target.style.borderColor = 'var(--border-hover)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.borderColor = 'var(--border-color)';
              }}
            >
              <div style={{
                width: '44px',
                height: '44px',
                background: '#25D366',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.548" />
                </svg>
              </div>
              <div style={{ textAlign: 'left' }}>
                <h4 style={{
                  margin: '0 0 4px 0',
                  fontSize: '15px',
                  fontWeight: '600',
                  color: 'var(--color-primary)'
                }}>
                  WhatsApp
                </h4>
                <p style={{
                  margin: 0,
                  fontSize: '12px',
                  color: 'var(--text-secondary)'
                }}>
                  {(language === 'en' ? 'Let\'s discuss' : 'Discutons directement')}
                </p>
              </div>
            </a>

            {/* Email */}
            <a
              href="mailto:gautheron.og@gmail.com"
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                background: 'var(--card-bg)',
                border: '2px solid var(--border-color)',
                borderRadius: '10px',
                textDecoration: 'none',
                color: 'var(--text-primary)',
                transition: 'all 200ms ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)';
                e.target.style.borderColor = 'var(--border-hover)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.borderColor = 'var(--border-color)';
              }}
            >
              <div style={{
                width: '44px',
                height: '44px',
                background: 'var(--color-accent)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="white"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </div>
              <div style={{ textAlign: 'left' }}>
                <h4 style={{
                  margin: '0 0 4px 0',
                  fontSize: '15px',
                  fontWeight: '600',
                  color: 'var(--color-primary)'
                }}>
                  {t('email')}
                </h4>
                <p style={{
                  margin: 0,
                  fontSize: '12px',
                  color: 'var(--text-secondary)'
                }}>
                  {(language === 'en' ? 'Send me an E-mail' : ' Envoyez-moi un E-mail')}
                </p>
              </div>
            </a>
          </div>

          {/* Additional Contact Info */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '24px',
            textAlign: 'center'
          }}>
            <div>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: 'var(--text-secondary)' }}>{t('phone')}</p>
              <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: 'var(--text-primary)' }}>+(33)6233006587</p>
            </div>
            <div>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: 'var(--text-secondary)' }}>{t('location')}</p>
              <p style={{ margin: 0, fontSize: '16px', fontWeight: '500', color: 'var(--text-primary)' }}>{t('address')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;